<div class="search-pagination-container">
  <mat-form-field appearance="fill" floatLabel="always">
    <mat-label>Search</mat-label>
    <input class="search" matInput placeholder="Search" [formControl]="searchForm" />
  </mat-form-field>
  
  <div *ngIf="itemCount > 0">
    <app-paginator 
      [itemCount]="itemCount"
      (pageEvent)="onPageEvent($event)">
    </app-paginator>
  </div>
</div>
